import { render, staticRenderFns } from "./actiontask.vue?vue&type=template&id=50e2b766&scoped=true&"
import script from "./actiontask.vue?vue&type=script&lang=js&"
export * from "./actiontask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e2b766",
  null
  
)

export default component.exports